import Select from '@components/Select'
import moment from 'moment-timezone'
import classNames from 'classnames'
import { GRID_BREAKPOINT_SM } from '@breakpoints'
import { getTimeFormat } from '@i18n/utils'
import { useMediaQuery } from 'react-responsive'
import Label from '../Label'

const createOption = (time, format) => ({
    label: time.format(format),
    value: time.valueOf(),
})

const createOptions = (step, unit, format, startTime) => {
    const start = startTime ? moment(startTime) : moment().startOf('day')
    const times = [start]

    while (true) {
        const next = times[times.length - 1].clone().add(step, unit)
        if ((startTime && next.isAfter(moment(startTime).endOf('day'))) || next.diff(start, 'days') >= 1) break
        times.push(next)
    }

    return times.map(time => createOption(time, format))
}

function TimePicker({ value = moment(), label, startTime, disabled, onChange, readOnly }) {
    const [time, setTime] = React.useState(value)
    const isTabletOrDesktop = useMediaQuery({ minWidth: GRID_BREAKPOINT_SM })

    const onTimeChange = ({ value }) => {
        let momentValue

        if (typeof value === 'string') momentValue = moment(value, getTimeFormat())
        else if (typeof value === 'number') momentValue = moment(value)

        if (momentValue && momentValue.isValid) {
            setTime(momentValue)
            onChange && onChange(momentValue)
        }
    }

    // when value changes from props, after initial render. Only update if value exists and is different from current time (compare by timestamp)
    React.useEffect(() => {
        if (value && (!time || value.valueOf() !== time.valueOf())) {
            setTime(value)
        }
    }, [value])

    const options = createOptions(30, 'minutes', getTimeFormat(), startTime)

    return (
        <div
            className={classNames('time-picker', {
                'time-picker--read-only': readOnly,
            })}>
            <Label>{label}</Label>
            <Select
                ariaLabel={<T>dashboard.label.time.select</T>}
                options={options}
                value={createOption(time, getTimeFormat())}
                isSearchable={false}
                size="small"
                onChange={onTimeChange}
                icon="clock"
                isDisabled={disabled || readOnly}
                readOnly={readOnly}
                arrow={!readOnly}
                isTabletOrDesktop={isTabletOrDesktop}
            />
        </div>
    )
}

TimePicker.propTypes = {
    // moment object
    startTime: PropTypes.shape({}),
    // moment object
    value: PropTypes.shape({}),
    disabled: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    // returns a moment object
    onChange: PropTypes.func,
    alwaysShowIcon: PropTypes.bool,
}
export default TimePicker
